/**
 * router/index.ts
 *
 * Automatic routes for `./src/pages/*.vue`
 */

// Composables
import { createRouter, createWebHistory } from 'vue-router/auto'
import { setupLayouts } from 'virtual:generated-layouts'
import { routes } from 'vue-router/auto-routes'

/*Scriptworx*/
import async from "async";
import { loginutils } from "sw-gw-gui";
import { clinic } from "sw-gw-gui";
import { swStore } from "sw-gw-gui";
import { user } from "sw-gw-gui";

const User = user.default

export const router = function (app) {

  var generatedRoutes = setupLayouts(routes)

  var customRoutes = [
    {
      path: '/prescriptions/:id?',
      component: app.component('SwPrescriptionView'),
      props: true,
      children: [
        {
          path: 'view',
          components: {
            'pre': app.component('SwPrescriptionPBSApproval'),
            'post': app.component('SwClinicList')
          },
        },
      ]
    },

    {
      path: '/clinics/:id?',
      component: app.component('SwClinicList'),
      props: true,
    },

  ]

  generatedRoutes.push(...customRoutes)

  var routeConfig = {
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: generatedRoutes
  }

  var newRouter = createRouter(routeConfig)



  // Workaround for https://github.com/vitejs/vite/issues/11804
  newRouter.onError((err, to) => {
    if (err?.message?.includes?.('Failed to fetch dynamically imported module')) {
      if (!localStorage.getItem('vuetify:dynamic-reload')) {
        console.log('Reloading page to fix dynamic import error')
        localStorage.setItem('vuetify:dynamic-reload', 'true')
        location.assign(to.fullPath)
      } else {
        console.error('Dynamic import error, reloading page did not fix it', err)
      }
    } else {
      console.error(err)
    }
  })

  newRouter.isReady().then(() => {
    localStorage.removeItem('vuetify:dynamic-reload')
  })


  //Start Scriptworx Gateway Routing
  newRouter.beforeEach((to, from, next) => {
    var selfTo = to;
    var store = swStore();

    var loginRedirect = { path: "/login" };

    if (selfTo.fullPath != "/") {
      console.log("Redirect detected: " + selfTo.fullPath);
      loginRedirect["query"] = { redirect: selfTo.fullPath };
    }

    if (to.path == "/login" || to.path == "/signup" || to.path == "/activate" || to.path == "resetpassword") {
      next();
      // return
    } else {
      var checkUser = async.compose(
        success,
        checkCurrentClinic,
        checkCurrentUser
      );
      checkUser();
    }

    function success(callback) {
      if (store.user !== undefined) {
        if (
          selfTo.path == "/" &&
          store.user.roles.indexOf("pharmacist") >= 0
        ) {
          next("/script_dispense_summary");
          return;
        }
        if (
          selfTo.path == "/" &&
          store.clinic.config.default_screen.length > 0
        ) {
          next("/" + store.clinic.config.default_screen);
          return;
        } else {
          next();
          return;
        }
      } else {
        next(loginRedirect);
      }
      callback(null);
    }

    function checkCurrentUser(callback) {
      return loginutils.currentUser()
        .then((result) => {
          if (result.user_id == "") {
            next(loginRedirect);
          }
          var user = new User();
          user.loadFromObj(result);
          store._user = user;
          return callback(null, result.cid);
        })
        .catch((err) => {
          console.log(err)
          console.log("Unable to get current user");
          next(loginRedirect);
        });
    }

    function checkCurrentClinic(cid, callback) {
      if (cid !== undefined && store.clinic != null) {
        //Check if Clinic is selected
        if (cid == store.clinic.cid) {
          //If same as existing clinic, continue
          return callback();
        }
      }

      return clinic.getCurrentClinic(callback)
        .then((clinic) => {
          if (clinic.cid != '') {
            clinic.loadUsers().then((result) => {
              if (result == false) {
                next(loginRedirect);
              }

              store._clinic = clinic
              return callback();
            });
          }
        })
        .catch(() => {
          console.log("Unable to get current clinic");
          return callback();
        });
    }
  });
  // End Scriptworx Gateway Routing

  return newRouter

}